export default __webpack_public_path__ + "static/media/energy.0aaf8ea5.svg";